import { c as _c } from "react/compiler-runtime";
import { PredictBlockNumbersResponseApiModel } from "@/app/tools/block-finder/page.client";
import BlockPickerResultTableHeader from "./BlockPickerResultTableHeader";
import BlockPickerResultTableRow from "./BlockPickerResultTableRow";
export default function BlockPickerResultTable(t0) {
  const $ = _c(5);
  const {
    predictedBlocks
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <BlockPickerResultTableHeader />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== predictedBlocks) {
    t2 = predictedBlocks.map(_temp);
    $[1] = predictedBlocks;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <div className="tw-mt-4 tw-flow-root"><div className="tw-overflow-x-auto tw-ring-1 tw-ring-white/10 tw-rounded-lg"><table className="tw-min-w-full tw-divide-y tw-divide-iron-700/60">{t1}<tbody className="tw-divide-y tw-divide-solid tw-divide-iron-700/60">{t2}</tbody></table></div></div>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}
function _temp(block) {
  return <BlockPickerResultTableRow key={block.blockNumberIncludes} predictedBlock={block} />;
}